import { DB_PREFIX, DB_PREFIX_INFO, DB_PREFIX_REGISTER } from './constants';

export default {
  [DB_PREFIX_REGISTER]: {
    registered: null,
  },
  [DB_PREFIX_INFO]: {
    dateOfBirth: '',
    firstName: '',
    lastName: '',
    nationality: null,
  },
  [DB_PREFIX]: {
    id: null,
    fileURL: '',
    permissionToCheckDBS: false,
  },
};
